<template>
<div>
    <div class="row">
        <div class="col-lg-12 mb-3 mb-md-0">
            <div class="row">
                <div class="col-lg-5">   
                    <div class="form-group">
                        <label>ค้นหาวันที่ส่งพัสดุ (วันเริ่มต้น - วันสุดท้าย)</label>
                        <div class="row">
                            <date-range-picker
                                class="w-100"
                                :opens="'center'"
                                @start-selection="logEvent('startSelection', $event)"
                                @finish-selection="logEvent('finishSelection', $event)"
                                :min-date="minDate"
                                :max-date="maxDate"
                                :singleDatePicker="false"
                                :appendToBody="true"
                                :ranges="false"
                                :closeOnEsc="false"
                                :autoApply="true"
                                :locale-data="{ format: 'dd/mm/yyyy' }"
                                v-model="filter.date.dateRange" >
                             </date-range-picker>
                        </div>
                    </div>
                </div>
                <div class="col-lg">
                    <div class="form-group">
                        <label>สถานะพัสดุ</label>
                        <select class="form-control" @click.stop.prevent 
                            v-model="filter.filterOfType.statusParcel">
                            <option :value="null">{{'ดูทั้งหมด'}}</option>
                            <option :value="status.key" v-for="status in status_parcel" :key="status.key">{{status.txt}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg" v-if="!isDisable">
                    <div class="form-group">
                        <label>ค้นหาร้านค้า</label>
                        <select class="form-control" @click.stop.prevent 
                            v-model="filter.filterOfType.selectShopFilter">
                            <option :value="null">{{'ดูทั้งหมด'}}</option>
                            <option :value="shop.id" v-for="shop in filter.shopList" :key="shop.id">{{ shop.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg custom-btn-sm-center">
                    <button class="btn btn-info btn-sm-res" 
                        @click="func.getReportCod()" >
                        <i class="fa fa-search"></i>
                    </button>
                </div>
                <div class="col-lg-2">
                    <div class="form-group">
                        <label>Export File</label>
                        <div class="btn-group btn-sm-res btn-export" role="group" aria-label="Basic example">
                            <ExportExcel 
                                :columns="getReportExcel()" 
                                :getData="formatExcel"
                                name="สรุปยอด COD " 
                                :disabled="listOrders.length == 0"
                            >
                            </ExportExcel>
                            <b-button variant="info btn-sm-res">print</b-button>
                        </div>
                    </div>
                </div>
            </div>
            <hr class="d-block d-md-none d-lg-none mb-0" />
        </div>
    </div>
    <div class="row">
        <div class="col-12 mb-3 mb-md-0">
            <b-form-group description="( หมายเลขใบเสร็จ , หมายเลขติดตามพัสดุ )"
                label="ค้นหาข้อมูล"
                class="mb-0" >
                <div class="row">
                    <div class="col-2">
                        <select class="form-control" @click.stop.prevent 
                        v-model="filter.filterOfType.fetchFilter">
                            <option value="receipt">
                                {{'เลขที่ใบเสร็จ'}}
                            </option>
                            <option value="tracking">{{'หมายเลขติดตามพัสดุ'}}</option>
                        </select>
                    </div>
                    <div class="col-3">
                        <b-form-input type="text" 
                            v-model="filter.filterOfType.textFilter"
                            placeholder="ค้นหาข้อมูล">
                        </b-form-input>
                    </div>
                    <div class="col">
                        <button class="btn btn-info btn-sm-res" 
                            @click="func.fetchOrders()" >
                        <i class="fa fa-search"></i>
                        </button>
                    </div>
                </div>
            </b-form-group>
        </div>
    </div>
</div>
</template>
<script>
import columnExcel from "./js/columnsCod.js"
import ExportExcel from '@/components/custom/exportExcel/ExportExcel'
import defaultStatusParcel from "../../../../assets/config/statusParcel.js"
import { getListOrderCodForExcel } from '@/axios/report.js';
import moment from "moment"
import { dateLimitRanges } from "@/plugins/datePicker.js"

export default {
    data(){
        return {
            userLogin: "" ,
            status_parcel: defaultStatusParcel.cod,
            dataListOrders: [],
            minDate: null,
            maxDate: moment().format("YYYY-MM-DD"),
        }
    },
    props:{
        func: Object , 
        filter: Object ,
        listOrders: Array ,
        limitDate: Object , 
        pagination: Object
    },
    components:{
        ExportExcel
    },
    mounted() {
        this.userLogin = JSON.parse(localStorage.getItem("user"))
        console.log('this.filter: ', this.filter)
    },
    computed:{
        isDisable(){
            return this.isWho() == 'admin' || this.isWho() == 'member'
        },
        columnForExportExcel(){
            let col = columnExcel
            col.push({ 
                field: 'shippop_receipt_id' , 
                key: "shippop_receipt_id", 
                label: "เลขที่ใบเสร็จ COD", 
                sortable: true 
            })
            col.push({ 
                field: 'receipt_id_url' , 
                key: "receipt_id_url", 
                label: "ใบเสร็จ COD", 
                sortable: true 
            })
            if( this.isMember() ){
                col.push( { field:'manage', key: "manage", label: "จัดการ" } );
            }
            if( this.isWho() == 'admin' || this.isWho() == 'member'){
                
                return col.filter(function (col) {
                    return [ 'shop_name' ].indexOf(col.key) < 0
                })
            }
            return col
        },
        dateMax(){
            return this.limitDate ? this.limitDate : {'start':false , 'end':false}
        },
    },
    methods:{
        logEvent( event , date ){
            const { minDate , maxDate } =  dateLimitRanges(event, date);
            this.minDate = minDate
            this.maxDate = maxDate
        },
        isWho(){
            return this.userLogin.role
        },
        async formatExcel(){

            // if( this.$THEME.exportLoading ){
            //     return this.$THEME.exportLoading
            // }

            let search = {
                start:  moment(this.filter.date.dateRange.startDate).format("YYYY-MM-DD"),
                end: moment(this.filter.date.dateRange.endDate).format("YYYY-MM-DD"),
                shop: this.filter.filterOfType.selectShopFilter,
                statusParcel :  this.filter.filterOfType.statusParcel,
                ...( ( this.$route.params.Id ) ? { mem_id: this.$route.params.Id } : {} ),
            }

            let total = { commission : 0 }

            await getListOrderCodForExcel( search , Math.ceil( (this.pagination.total_item/this.pagination.per_page) ) ).then( resListOrders => {
                this.dataListOrders = [ ...resListOrders ];
            })

            if(this.listOrders.length > 0){
                this.dataListOrders.forEach(item => {
                    if( item.status != 'PENDING_CANCEL' && item.status != 'CANCEL' ){
                        total.commission += +item.commission
                    }
                });
                let format = {
                    index: '',
                    shop_name:'',
                    receipt_no:'',
                    barcode:'',
                    date_time_shipping:'',
                    date_time_complete:'',
                    status:'',
                    to_name:'',
                    sender:'',
                    date_time_transfer:'',
                    cod_amount:'',
                    service_fee:'',
                    vat:'',
                    r_cod_amount:'',
                    commission: total.commission,
                    status_transfer:'',
                    shippop_receipt_id: '',
                    receipt_id_url:''
                }
                this.dataListOrders.push(format);
            }
            return this.dataListOrders;
        },
        getReportExcel(){
            let fields = []
            this.isWho() != 'admin' || this.isWho() != 'member' ? fields = ['index','shop_name','manage'] : fields = ['index']
            return [
                ...columnExcel,
                { 
                    field: 'shippop_receipt_id' , 
                    key: "shippop_receipt_id", 
                    label: "เลขที่ใบเสร็จ COD", 
                    sortable: true 
                },
                {
                    field: 'receipt_id_url', 
                    key: 'receipt_id_url', 
                    label:'ใบเสร็จ COD'
                }
            ].filter(function (col) {
                return fields.indexOf(col.key) < 0
            })
        },
    }
}
</script>
<style lang="scss" scoped>
    .custom-btn-sm-center{
        display: flex;
        align-items: center;
        margin-top: 17px;
    }
</style>